<template>
    <!--弹窗-->
    <el-dialog
        width="500px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="120px"
            size="mini"
        >
            <el-form-item label="国家：" prop="state">
                <el-select
                    v-model="formData.state"
                    ref="carrerSelect"
                    style="width: 150px;margin-top: 5px"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in stateArr"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.value"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                                >{{ item.name }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ASIN：">
                <el-input
                    v-model="asin"
                    style="width: 250px;margin-right:20px;"
                    maxlength="10"
                    placeholder="请输入ASIN"
                    @input="inputChange"
                    v-loading="loading"
                    :disabled="!formData.state"
                ></el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as apis from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            formData: {},
            stateArr: [
                {
                    name: "美国",
                    value: "US"
                },
                {
                    name: "英国",
                    value: "UK"
                },
                {
                    name: "德国",
                    value: "DE"
                }
            ],
            asin: "",
            rules: {
                asin: [
                    {
                        required: true,
                        message: "请输入合法的ASIN",
                        trigger: "blur"
                    }
                ],
                state: [
                    {
                        required: true,
                        message: "请现在国家",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    if (!this.formData.asin) {
                        return this.$message({
                            type: "error",
                            message: "请填写合法的ASIN!"
                        });
                    }
                    this.formData.asin = this.asin;
                    this.loading = true;
                    apis.seed_word_asin_list_add(this.formData)
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "添加成功"
                                });
                                this.handleClose(false);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message:
                                    "网络出现问题，请查看数据是否添加完成！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        //获取ASIN内容数据
        inputChange(val) {
            this.formData.asin = this.asin.toUpperCase();
            //
            // if (val.length < 10) {
            //     return;
            // }
            // this.loading = true;
            // apis.asin_info({ asin: val, country_code: this.formData.state })
            //     .then(res => {
            //         this.loading = false;
            //         if (res.code === 0) {
            //             this.formData.asin = this.asin.toUpperCase();
            //         } else {
            //             this.formData.asin = "";
            //         }
            //     })
            //     .catch(() => {
            //         this.loading = false;
            //         this.$message({
            //             type: "error",
            //             message: "网络出现问题，请刷新页面！"
            //         });
            //     });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {};
            this.asin = "";
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
</style>
